import { useQuery } from '@tanstack/react-query';
import { deliveryTrackingService } from '../services/delivery-tracking.service';

export function useDeliveryCompanies() {
  return useQuery({
    queryKey: ['delivery-companies'],
    queryFn: () => deliveryTrackingService.getActiveDeliveryCompanies(),
  });
}
